import { render, staticRenderFns } from "./CreateClaim.vue?vue&type=template&id=4ca5e040&scoped=true&"
import script from "./CreateClaim.vue?vue&type=script&lang=js&"
export * from "./CreateClaim.vue?vue&type=script&lang=js&"
import style0 from "./CreateClaim.vue?vue&type=style&index=0&id=4ca5e040&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5e040",
  null
  
)

export default component.exports